import { Button, Modal, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setIsAcknowledged, setShowToSModal } from "../../../redux/slices/userSlice";
import { AppDispatch } from "../../../redux/store";
import { Link } from "react-router-dom";
import { fetchUpdateFirestore } from "../../../redux/slices/updateFieldSlice";
import { showPromo } from "../../../redux/slices/IntroPromoSlice";
import { currentVersion } from "../../terms_and_policies/TermsAndPolicies";

const links = [
  { to: "/policies/service-terms", label: "Terms of Service" },
  { to: "/policies/privacy-policy", label: "Privacy Policy" },
  { to: "/policies/legal-disclaimer", label: "Legal Disclaimer" },
  { to: "/policies/take-down-policy", label: "Take Down Procedure" },
];

const ToSModal = () => {
  const { showToSModal, user, isNewUser } = useSelector((state: { user }) => state.user);
  const dispatch = useDispatch<AppDispatch>();

  const handleCloseToSModal = () => {
    if (!user?.tradegpt) return;
    const signedAgreement = {
      [currentVersion]: Date.now(),
    };
    const updatedTradeGPT = {
      tradegpt: {
        ...user.tradegpt,
        signed_agreement: {
          ...user.tradegpt.signed_agreement,
          ...signedAgreement,
        },
      },
    };
    dispatch(fetchUpdateFirestore({ firestoreFields: updatedTradeGPT }));
    dispatch(setShowToSModal(false));
    dispatch(setIsAcknowledged(true)); // optimistic update of acknowledgement while firebase user is still updating
    if (isNewUser) {
      dispatch(showPromo());
    }
  };

  return (
    <Modal
      disableEscapeKeyDown
      open={showToSModal}
    >
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow w-modal-mobile sm:w-modal-md rounded-lg p-6 bg-white text-mui-black-87 dark:bg-background/paper-elevation-16 dark:text-white">
        <div className="flex flex-col gap-y-4">
          <Typography variant="h6/medium-500" className="font-medium">We have updated our terms</Typography>
          <Typography variant="body2/regular-400">
            By accepting, you acknowledge that you have read and agree to these updated terms & policies.
          </Typography>
          <ul className="list-disc ps-4 text-info-main pb-1">
            {links.map(({ to, label }) => (
              <li key={to} className="pb-1">
                <Link to={to}>
                  <Typography variant="body2/regular-400">{label}</Typography>
                </Link>
              </li>
            ))}
          </ul>
          <Button
            className="!text-transform-none !bg-primary-blue-main w-1/2 self-center"
            variant="contained"
            color="primary"
            size="large"
            onClick={() => handleCloseToSModal()}
          >
            Accept
          </Button>

        </div>
      </div>
    </Modal>

  );
};

export default ToSModal;
